import { render } from "./allstockadjustment.vue?vue&type=template&id=b654412a&scoped=true"
import script from "./allstockadjustment.vue?vue&type=script&lang=js"
export * from "./allstockadjustment.vue?vue&type=script&lang=js"

import "./allstockadjustment.vue?vue&type=style&index=0&id=b654412a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b654412a"]])

export default __exports__